'use client';

import {
  preferredUsernameQuery,
  supporterAddressQuery,
  supporterContactPreferencesQuery,
  supporterContactsQuery,
} from '../queries.ts';
import { useSupporterQuery } from './base.ts';
import { useSupporterDetails } from './details.ts';

export const useAccountSettings = () => {
  const { data: supporter, isPending: supporterPending } =
    useSupporterDetails();
  const { data: supporterAddress, isPending: addressPending } =
    useSupporterQuery(supporterAddressQuery);
  const { data: preferredUsername, isPending: usernamePending } =
    useSupporterQuery(preferredUsernameQuery);
  const { data: contacts, isLoading: contactsPending } = useSupporterQuery(
    supporterContactsQuery,
  );

  return {
    supporter,
    supporterAddress,
    preferredUsername,
    contacts,
    showSkeleton:
      supporterPending || addressPending || usernamePending || contactsPending,
  };
};

export const useContactsSettings = () => {
  const { data: contacts, isLoading: contactsPending } = useSupporterQuery(
    supporterContactPreferencesQuery,
  );

  return {
    contacts,
    showSkeleton: contactsPending,
  };
};
